<template>
  <main
    class="main-content flex-grow-1 p-4 overflow-auto mt-6"
    style="background-color: #f8f9fa"
  >
    <template v-if="kybStatus == 'waiting' || kybStatus == 'basic'">
      <h2 class="h4 mb-1">Congratulation, your account has been created!</h2>
      <p class="text-muted mb-4">
        Verify you account to unlock {{ brandName }} features.
      </p>
    </template>
    <template v-if="kybStatus === 'rejected'">
      <div class="row">
        <div class="col-md-8">
          <VerificationRejectedAlert :reason="rejectReason" />
        </div>
      </div>
    </template>
    <template v-if="kybStatus === 'basic' || kybStatus === 'waiting'">
      <div class="row">
        <div class="col-md-6">
          <div class="card mb-4">
            <div class="card-body p-4">
              <div
                class="d-flex justify-content-between align-items-center mb-4"
              >
                <div>
                  <h5 class="card-title mb-0">Complete Setup</h5>
                  <small class="text-muted"
                    >All changes will automatically saved</small
                  >
                </div>
                <div class="text-end">
                  <small class="text-muted"
                    >{{ completedSteps }}/4 completed</small
                  >
                  <div class="progress mt-1" style="width: 120px; height: 8px">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      :style="{ width: progressPercentage + '%' }"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>

              <ul class="list-unstyled setup-steps">
                <li class="d-flex align-items-center border-bottom py-3">
                  <div
                    class="step-number rounded-circle text-center me-3"
                    :class="{
                      'bg-info text-white': isRegister === true,
                      'bg-light': isRegister !== true,
                    }"
                    style="width: 30px; height: 30px; line-height: 30px"
                  >
                    <i v-if="isRegister === true" class="fas fa-check"></i>
                    <span v-else>1</span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold">Create Account</h6>
                    <small class="text-muted">Account creation completed</small>
                  </div>
                </li>
                <li class="d-flex align-items-center border-bottom py-3">
                  <div
                    class="step-number rounded-circle text-center me-3"
                    style="width: 30px; height: 30px; line-height: 30px"
                    :class="{
                      'bg-info text-white': isDetailCompany === true,
                      'bg-light text-muted': isDetailCompany !== true,
                    }"
                  >
                    <i v-if="isDetailCompany === true" class="fas fa-check"></i>
                    <span v-else>2</span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold">Detail Information</h6>
                    <small class="text-muted"
                      >Detail information about your business</small
                    >
                  </div>
                  <button
                    v-if="isDetailCompany !== true"
                    class="btn btn-success btn-sm btn-custom ms-3 px-3"
                    @click="$router.push('/company-detail')"
                  >
                    Start Now
                  </button>
                </li>
                <li class="d-flex align-items-center border-bottom py-3">
                  <div
                    class="step-number rounded-circle text-center me-3"
                    style="width: 30px; height: 30px; line-height: 30px"
                    :class="{
                      'bg-info text-white': isDocumentCompany === true,
                      'bg-light text-muted': isDocumentCompany !== true,
                    }"
                  >
                    <i
                      v-if="isDocumentCompany === true"
                      class="fas fa-check"
                    ></i>
                    <span v-else>3</span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold">Document</h6>
                    <small class="text-muted"
                      >Upload your legal entity documents</small
                    >
                  </div>
                  <button
                    v-if="isDocumentCompany !== true"
                    class="btn btn-light btn-sm btn-custom ms-3 px-3"
                    :class="{ disabled: isDetailCompany != true }"
                    @click="$router.push('/company-document')"
                  >
                    Upload
                  </button>
                </li>
                <li class="d-flex align-items-center pt-3">
                  <div
                    class="step-number rounded-circle text-center me-3"
                    style="width: 30px; height: 30px; line-height: 30px"
                    :class="{
                      'bg-info text-white': isBankOwner === true,
                      'bg-light text-muted': isBankOwner !== true,
                    }"
                  >
                    <i v-if="isBankOwner === true" class="fas fa-check"></i>
                    <span v-else>4</span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold">Bank Account</h6>
                    <small class="text-muted"
                      >Bank Account is needed for refund destination</small
                    >
                  </div>
                  <button
                    v-if="isBankOwner !== true"
                    class="btn btn-light btn-sm btn-custom ms-3 px-3"
                    :class="{ disabled: isDocumentCompany != true }"
                    @click="$router.push('/company-bank')"
                  >
                    Add Bank
                  </button>
                </li>
              </ul>
            </div>
            <div class="card-footer p-3" v-if="kybStatus === 'waiting'">
              <div
                class="alert mb-0 d-flex align-items-center"
                role="alert"
                style="background-color: #fffacd"
              >
                <div class="me-3">
                  <i
                    class="fas fa-clock"
                    aria-hidden="true"
                    style="font-size: 1.5rem"
                  ></i>
                </div>
                <div>
                  <strong>Waiting for Approval</strong> <br />
                  <small
                    >Your submission is under review, please wait for our team
                    approval</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="kybStatus === 'approved'">
      <h2 class="h4 mb-1 text-header">Home</h2>
      <div class="row mt-3" v-if="!isDemoAccount">
        <div class="col-md-8">
          <BalanceCard :balance="balance" :loading="balanceLoading" />
        </div>
        <div class="col-md-4">
          <Chart :loading="balanceLoading" />
        </div>
      </div>
      <div class="row mt-3 p-2">
        <div class="card">
          <div class="card-body">
            <h4 class="text-recent-transaction">Recent Transaction</h4>
            
            <!-- Skeleton Loader for Transaction Table -->
            <div v-if="balanceLoading" class="skeleton-table-container">
              <div class="skeleton-table-header">
                <div class="skeleton-text skeleton-table-cell" v-for="i in 6" :key="i"></div>
              </div>
              <div class="skeleton-table-row" v-for="i in 3" :key="i">
                <div class="skeleton-text skeleton-table-cell" v-for="j in 6" :key="j"></div>
              </div>
            </div>
            
            <!-- Actual Content -->
            <div v-else>
              <TableComponent :data="transactions" :columns="tableColumns">
                <template v-slot:action="{ row }">
                  <button
                    class="view-detail-btn"
                    @click="viewDetail(row)"
                  >
                    View Details
                  </button>
                </template>
                <!-- <template v-slot:status="{ row }">
                    {{ row.status }}
                </template> -->
              </TableComponent>
              <PaginationComponent
                :totalItems="totalItems"
                :currentPage="currentPage"
                :totalPages="totalPages"
                :displayedPages="displayedPages"
                @page-change="changePage"
              />
            </div>
          </div>
        </div>
      </div>
      <Confetti v-if="popUp === 'verified'" @close="closeConfettiModal" />
    </template>
    
    <!-- Speak with Expert Section -->
    <div class="row mt-3">
      <div class="col-md-8">
        <!-- Skeleton Loader for Help Section -->
        <div v-if="balanceLoading" class="skeleton-help-card">
          <div class="skeleton-help-content">
            <div class="skeleton-help-icon"></div>
            <div class="skeleton-help-text">
              <div class="skeleton-text skeleton-help-title"></div>
              <div class="skeleton-text skeleton-help-subtitle"></div>
            </div>
            <div class="skeleton-help-button"></div>
          </div>
        </div>
        
        <!-- Actual Content -->
        <div
          v-else
          class="card border-0 shadow-sm bg-dark text-white help-card"
          :style="{ backgroundImage: 'url(/assets/bg-help.png)' }"
        >
          <div class="card-body p-4 d-flex align-items-center">
            <div class="me-3">
              <img
                src="/assets/call.png"
                alt="Phone Icon"
                class="help-icon"
                @error="handleImageError"
              />
            </div>
            <div class="flex-grow-1">
              <h3 class="card-title mb-1 text-white">Speak with Expert</h3>
              <p class="mb-0 small opacity-75">
                Our team is ready to help you simplify and scale your payment
                processes.
              </p>
            </div>
            <div>
              <button
                class="btn btn-success px-4"
                @click="$router.push('/help-center')"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import TableComponent from "../../components/Table/TableComponent.vue";
import PaginationComponent from "../../components/Table/PaginationComponent.vue";
import Confetti from "./Confetti.vue";
import { getProfile } from "../../api/company";
import { getListBatch } from "../../api/transaction";
import { getBalance } from "../../api/balance";
import VerificationRejectedAlert from "./Reject.vue";
import Chart from "./Chart.vue";
import BalanceCard from "./Balance.vue";

import { onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useBranding } from "@/utils/branding";
import { isAkunDemo } from "@/utils/role-utils";

export default {
  components: {
    TableComponent,
    PaginationComponent,
    Confetti,
    VerificationRejectedAlert,
    Chart,
    BalanceCard,
  },
  data() {
    const { brandName } = useBranding();
    return {
      brandName,
      transactions: [],
      tableColumns: [
        { key: "batch_id", label: "Batch Id" },
        { key: "batch_datetime", label: "Date & Time" },
        { key: "grand_total_amount", label: "Total Amount" },
        { key: "total_recipient", label: "Total Recipient" },
        { key: "status", label: "Status" },
        {
          key: "action",
          label: "Action",
          formatter: () => {
            return `<button class="btn btn-primary btn-sm" @click="$router.push('/transaction/' + item.uuid)">View Details</button>`;
          },
        },
      ],
      totalItems: 0,
      currentPage: 1,
      totalPages: 1,
      displayedPages: [1],
      itemsPerPage: 10,
      isRegister: 1,
      isDetailCompany: "",
      isDocumentCompany: "",
      isBankOwner: "",
      popUp: "",
      submitDate: "",
      balance: 0,
      companyName: "",
      fullname: "",
      email: "",
      merchantId: 0,
      kybStatus: "",
      rejectDate: "",
      rejectReason: "",
      balanceLoading: false,
    };
  },
  setup() {
    const store = useStore();

    onBeforeUnmount(() => {
      store.state.showTransferNavbar = false;
    });
  },
  computed: {
    completedSteps() {
      return [
        this.isRegister,
        this.isDetailCompany,
        this.isDocumentCompany,
        this.isBankOwner,
      ].filter((step) => step === true).length;
    },
    progressPercentage() {
      return (this.completedSteps / 4) * 100;
    },
    isDemoAccount() {
      return isAkunDemo();
    },
  },
  methods: {
    async getProfileMerchant() {
      this.balanceLoading = true;
      try {
        const response = await getProfile();
        if (response.status == "success") {
          this.isRegister = true;
          this.isDetailCompany = response.data.merchant.pages.page_1;
          this.isDocumentCompany = response.data.merchant.pages.page_2;
          this.isBankOwner = response.data.merchant.pages.page_3;
          this.popUp = response.data.merchant.popup;
          this.submitDate = response.data.merchant.submited_date;
          this.balance = new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
          }).format(response.data.merchant.balance);
          this.merchantId = response.data.merchant.id;
          this.companyName = response.data.merchant.company_name;
          this.fullname = response.data.merchant.fullname;
          this.email = response.data.merchant.email;
          this.kybStatus = response.data.merchant.status_kyb;
          this.rejectDate = response.data.merchant.rejected_date;
          this.rejectReason = response.data.merchant.rejected_reason;

          // Ensure users with non-approved KYB status cannot have production environment
          // Use environment from profile if available, otherwise from store
          const environmentFromProfile = response.data.merchant.environment;
          const currentEnvironment = environmentFromProfile || this.$store.getters.currentEnvironment;

          // Sync environment from profile to store
          if (environmentFromProfile) {
            this.$store.dispatch("changeEnvironment", environmentFromProfile);
          }

          if (currentEnvironment === "production" && this.kybStatus !== "approved") {
            this.$store.dispatch("changeEnvironment", "sandbox");
          }

          if (this.kybStatus === "approved") {
            this.fetchTransaction();
            this.fetchBalance();
          } else {
            // If not approved, stop loading since balance is already set from profile
            this.balanceLoading = false;
          }
        }
      } catch (error) {
        this.$swal({
          title: "Session Expired",
          text: "Your login session has expired. Please log in again to continue.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Login Again",
          cancelButtonText: "Logout",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33"
        }).then(async () => {
          try {
            const result = await this.$store.dispatch('auth/logout');
            if (result.success) {
              this.$router.push('/signin');
            } else {
              // If logout fails, still redirect to signin
              this.$router.push('/signin');
            }
          } catch (error) {
            console.error('Logout error:', error);
            // Force redirect to signin even if logout API fails
            this.$router.push('/signin');
          }
        });
        this.balanceLoading = false;
      }
    },
    async fetchTransaction() {
      if (this.kybStatus !== "approved") return;
      try {
        const response = await getListBatch();
        this.transactions = (response.data.data || []).slice(0, 5); // Limit to 5 rows
      } catch (error) {
        this.$swal("Failed to fetch batch data:");
      }
    },
    async fetchBalance() {
      if (this.kybStatus !== "approved") return;
      this.balanceLoading = true;
      try {
        const response = await getBalance();
        this.balance = response.data.merchant.balance;
      } catch (error) {
        this.$swal("Failed to fetch balance data");
      } finally {
        this.balanceLoading = false;
      }
    },
    closeConfettiModal() {
      this.popUp = "";
    },
    changePage(page) {
      this.currentPage = page;
      this.fetchAccounts();
    },
    fetchAccounts() {
      this.accounts = [];
      this.totalItems = this.accounts.length;
      this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.displayedPages = this.calculateDisplayedPages();
    },
    calculateDisplayedPages() {
      const pages = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    handleImageError(event) {
      event.target.src = "/assets/call.png"; // Fallback to a default image
    },
    viewDetail(row) {
      if (row.status && row.status.toLowerCase() === 'draft') {
        // Arahkan ke Transfer.vue step PreviewEntriesStep
        this.$router.push({
          path: '/transfer',
          query: {
            currentStep: 2,
            batchId: row.uuid || row.id || row.batch_id
          }
        });
      } else {
        // Default: detail batch - gunakan identifier yang tersedia
        const id = row.uuid || row.id || row.batch_id;
        this.$router.push('/transaction/' + id);
      }
    }
  },
  created() {
    this.getProfileMerchant();
    this.fetchAccounts();
  },
};
</script>

<style scoped>
.main-content {
  background-color: #f8f9fa;
}

.text-header {
  font-family: "IBM Plex Sans Devanagari";
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0%;
  vertical-align: middle;
}

.setup-steps .step-number {
  font-weight: bold;
  color: #6c757d;
}

.card {
  border-radius: 0.5rem;
}

/* Skeleton Loader Styles */
.skeleton-help-card {
  background-color: #e0e0e0;
  border-radius: 0.5rem;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.skeleton-help-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.skeleton-help-icon {
  width: 40px;
  height: 40px;
  background-color: #c0c0c0;
  border-radius: 50%;
}

.skeleton-help-text {
  flex-grow: 1;
}

.skeleton-text {
  background-color: #c0c0c0;
  border-radius: 0.25rem;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-help-title {
  width: 60%;
  height: 1.25rem;
  margin-bottom: 0.5rem;
}

.skeleton-help-subtitle {
  width: 80%;
  height: 1rem;
}

.skeleton-help-button {
  width: 80px;
  height: 30px;
  background-color: #c0c0c0;
  border-radius: 0.25rem;
}

@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

/* New styles for Speak with Expert section */
.help-card {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0.5rem;
  overflow: hidden;
}

.help-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* Skeleton Table Styles */
.skeleton-table-container {
  margin-top: 1.5rem;
}

.skeleton-table-header {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 0.375rem;
}

.skeleton-table-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.skeleton-table-cell {
  flex: 1;
  height: 1.25rem;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 0.25rem;
}

.skeleton-table-cell:first-child {
  flex: 1.5;
}

.skeleton-table-cell:last-child {
  flex: 0.8;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* View Detail Button Styling */
.view-detail-btn {
  background-color: white;
  color: black;
  border: 1px solid #dae0e2;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.15s ease-in-out;
}

/* .view-detail-btn:hover {
  background-color: #0056b3;  
} */

.text-recent-transaction {
  color: #333;
  font-weight: 600;
  margin-bottom: 1rem;
}
</style>
